// Option Last (/service-entry-optionlast): select a card, read the details in a side panel, then book.
// Below 1280px the panel becomes a bottom sheet that opens when a card is tapped.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NO_DESCRIPTION, tileClassName, useServiceColumns } from "./serviceData";
import { ServiceEntryShell, TileFace } from "./shared";

function DetailsPanel({ item, columnTitle, sheetOpen, onClose }) {
  const [choice, setChoice] = useState(0);
  useEffect(() => setChoice(0), [item.label]);

  const option = item.options ? item.options[choice] : null;

  return (
    <aside
      className={`se-details${sheetOpen ? " is-open" : ""}`}
      aria-label="Session details"
      aria-live="polite"
    >
      <button type="button" className="se-details-close" aria-label="Close details" onClick={onClose}>
        ✕
      </button>
      <span className="se-details-eyebrow">{columnTitle}</span>
      <h3 className="se-details-title">{item.label}</h3>
      {item.disabled ? (
        <span className="se-details-chip se-details-chip--muted">Not available at your level</span>
      ) : (
        item.groupEvent && <span className="se-details-chip">Group session</span>
      )}
      <p className="se-details-text">{item.description || NO_DESCRIPTION}</p>

      {item.disabled ? (
        <button type="button" className="se-details-btn" disabled>
          Not available at your level
        </button>
      ) : item.options ? (
        <>
          <span className="se-details-choice-title">{item.optionsTitle}</span>
          <div className="se-details-choices">
            {item.options.map((opt, i) => (
              <button
                type="button"
                key={opt.label}
                aria-pressed={choice === i}
                onClick={() => setChoice(i)}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <Link className="se-details-btn" to={option.to} onClick={option.onClick}>
            Continue with {option.label}
          </Link>
        </>
      ) : (
        <Link className="se-details-btn" to={item.to} onClick={item.onClick}>
          Continue
        </Link>
      )}
    </aside>
  );
}

export default function ServiceEntryOptionLast() {
  const columns = useServiceColumns();
  const [selected, setSelected] = useState(columns[0].items[0].label);
  const [sheetOpen, setSheetOpen] = useState(false);

  useEffect(() => {
    if (!sheetOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && setSheetOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [sheetOpen]);

  let selectedItem = columns[0].items[0];
  let selectedColumn = columns[0].title;
  columns.forEach((column) =>
    column.items.forEach((item) => {
      if (item.label === selected) {
        selectedItem = item;
        selectedColumn = column.title;
      }
    })
  );

  return (
    <ServiceEntryShell
      variant="c"
      hint="Select a card to read about it, then continue to book."
      aside={
        <>
          {sheetOpen && (
            <div className="se-details-backdrop" aria-hidden="true" onClick={() => setSheetOpen(false)} />
          )}
          <DetailsPanel
            item={selectedItem}
            columnTitle={selectedColumn}
            sheetOpen={sheetOpen}
            onClose={() => setSheetOpen(false)}
          />
        </>
      }
    >
      <div className="service-entry-columns">
        {columns.map((column) => (
          <section className="service-entry-column" key={column.title}>
            <h2>{column.title}</h2>
            <div className="service-entry-list">
              {column.items.map((item) => (
                <button
                  type="button"
                  key={item.label}
                  className={tileClassName(item, [selected === item.label ? "se-tile--selected" : ""])}
                  aria-pressed={selected === item.label}
                  onClick={() => {
                    setSelected(item.label);
                    setSheetOpen(true);
                  }}
                >
                  <TileFace item={item}>
                    {item.options && (
                      <span className="se-card-hint">
                        {item.options.map((o) => o.label).join(" · ")}
                      </span>
                    )}
                  </TileFace>
                </button>
              ))}
            </div>
          </section>
        ))}
      </div>
    </ServiceEntryShell>
  );
}
